import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import VideoComponent from "components/core/video/video-component";
import componentStyles from "./asset-part-component.scss";
class AssetPartComponent extends PureComponent {
    getVideoType(videoUrl) {
        return videoUrl.split(".").pop();
    }
    render() {
        const { playsInline, autoPlay, muted, loop, theme } = this.props;
        const { formats, poster } = this.props.assetProps;
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + `asset-part-component ${theme}`,
            children: [
                /*#__PURE__*/ _jsx(VideoComponent, {
                    formats: formats,
                    loop: loop,
                    muted: muted,
                    poster: poster,
                    playsInline: playsInline,
                    autoPlay: autoPlay
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
}
export { AssetPartComponent as default };
AssetPartComponent.defaultProps = {
    playsInline: true,
    autoPlay: true,
    muted: true,
    loop: true
};
